import { DateTime } from "luxon";
import { Navigate, useParams } from "react-router-dom";

import { useBotAnalyticsData } from "../../../Components/BotAnalyticsDashboard/Helpers/useBotAnalyticsData";
import { ViewAllProfileCollect } from "../../../Components/BotAnalyticsDashboard/Renders/ViewAllProfileCollect";
import { Member } from "../../../Models/Member/Member.Current";

export const CRMView = () => {
  const { startDate, endDate } = useParams<{ startDate: string; endDate: string }>();

  if (!startDate || !endDate) {
    const end = DateTime.now().toISODate();
    const start = DateTime.now().minus({ days: 30 }).toISODate();
    return <Navigate to={`/analytics/crm/${start}/${end}`} replace />;
  }

  const data = useBotAnalyticsData(Member.orgId!, startDate, endDate);

  return (
    <ViewAllProfileCollect
      rawProfileCollectData={data.rawProfileCollectData}
      locationNames={data.locationNames}
      onViewLess={() => {}}
      startDay={startDate}
      endDay={endDate}
    />
  );
};
